import branchFundingSourceComponent from './branch_funding_source.component';
import BranchFundingSourceAll from './all'
import BranchFundingSourceCreate from './create'
import BranchFundingSourceEdit from './edit'

let branchFundingSourceModule = angular.module('branchFundingSource', [
    BranchFundingSourceAll,
    BranchFundingSourceCreate,
    BranchFundingSourceEdit
])

  .component('branchFundingSource', branchFundingSourceComponent)

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
      .state('branch-funding-source.all', {
        url: '/all/:page',
        component: 'branchFundingSourceall',
        data: {
          requireACL: 'setting-branch-funding-source.view'
        }        
      })

      .state('branch-funding-source.create', {
        url: '/create',
        component: 'branchFundingSourcecreate',
        data: {
          requireACL: 'setting-branch-funding-source.create'
        }
      })

      .state('branch-funding-source.edit', {
        url: '/edit/:id',
        component: 'branchFundingSourceedit',
        data: {
          requireACL: 'setting-branch-funding-source.edit'
        }
      })
  })

  .name;

export default branchFundingSourceModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source/index.js